<template>
  <div class="ocean-ui-dialog-page" :class="{ 'has-other-tips': tips }">
    <transition name="scale-in" @after-leave="closeDialog">
      <div
        v-if="showContent"
        class="dialog-container"
        :class="{ noRightCenterNotice: textAlign !== 'left' }"
      >
        <div class="tips-dialog-wrapper">
          <p class="dialog-title" :class="{ autoHeight }">{{ myTitle }}</p>

          <div
            class="dialog-tips-content"
            :class="[
              textAlign,
              {
                notice: limitText && limitText.length > 0,
                autoHeight
              }
            ]"
            v-html="content"
            @click="handleContentClick"
          ></div>
          <p v-if="tips" class="tips-tips">{{ tips }}</p>
          <div v-if="type == 'tips'" class="account-ops">
            <Button
              class="swtich-account btn long-btn"
              pointClass="j-sure-tip-btn"
              @click="sendConfirmEvt"
            >
              {{ myConfirm }}
            </Button>
          </div>
          <div v-else class="account-ops">
            <Button
              class="cencel-account btn cancel-btn"
              pointClass="j-cancle-tip-btn"
              @click="sendCancelEvt"
            >
              {{ myCancel }}
            </Button>
            <Button
              class="swtich-account btn confirm-btn"
              pointClass="j-sure-tip-btn"
              @click="sendConfirmEvt"
            >
              {{ myConfirm }}
            </Button>
          </div>
          <div class="daysLimit" v-if="+daysLimit > 0">
            <a
              href="javascript:void(0);"
              class="popupCheck"
              :class="{ active: daysLimitCheck }"
              @click="daysLimitCheck = !daysLimitCheck"
            ></a>
            <span class="text">{{ limitText }}</span>
          </div>
        </div>
        <Button
          class="close-btn"
          pointClass="j-close-tip-btn"
          @click="hideContent"
        ></Button>
      </div>
    </transition>
    <transition name="fade-in">
      <div
        v-if="showContent"
        @click="hideContent"
        class="ocean-ui-dialog-buttom"
      ></div>
    </transition>
  </div>
</template>

<script>
import bridge from '@utiles/officialStore/bridge';
import globalConfig from '@utiles/officialStore/globalConfig';
export const CLOSE_DIALOG_EVENT = 'close_dialog';
export const CANCEL_EVENT = 'onCancel';
export const CONFIRM_EVENT = 'onConfirm';
export const SHOW_TIPS = 'showTipsDialog';
export const RESET_CONFIG = 'resetConfig';
export default {
  props: [
    'content',
    'title',
    'cancel',
    'confirm',
    'languages',
    'type',
    'tips',
    'textAlign',
    'daysLimit',
    'limitKey',
    'limitText',
    'autoHeight'
  ],
  data() {
    return {
      showContent: false,
      operateType: '',
      daysLimitCheck: false
    };
  },
  computed: {
    myTitle() {
      let tips = '';
      try {
        tips = this.title || this.languages.tips.toUpperCase();
      } catch {
        tips = 'tips';
      }
      return tips;
    },
    myCancel() {
      let cancel = '';
      try {
        cancel = this.cancel || this.languages.cancel.toUpperCase();
      } catch {
        cancel = 'CANCEL';
      }
      return cancel;
    },
    myConfirm() {
      let confirm = '';
      try {
        confirm = this.confirm || this.languages.confirm.toUpperCase();
      } catch {
        confirm = 'COMFIRM';
      }
      return confirm;
    }
  },
  mounted() {
    this.showContent = true;
  },
  methods: {
    closeDialog() {
      if (this.type === 'newPopupWindow' && this.operateType === 'confirm') {
        this.$emit(CONFIRM_EVENT);
        return;
      }
      this.$emit(CANCEL_EVENT);
      if (this.operateType === 'confirm') {
        this.$emit(CONFIRM_EVENT);
      }
    },
    hideContent() {
      this.showContent = false;
    },
    sendCancelEvt() {
      this.hideContent();
      this.operateType = 'cancel';
    },
    sendConfirmEvt() {
      this.hideContent();
      this.operateType = 'confirm';
      if (this.type === 'tips' && +this.daysLimit > 0) {
        globalConfig.setCookieWithinDays(`${this.limitKey}_TODAY`, true, 1); // 记录当天已弹出
        this.daysLimitCheck &&
          globalConfig.setCookieWithinDays(
            this.limitKey,
            true,
            +this.daysLimit
          ); // 记录7天内不弹出
      }
    },
    handleContentClick(e) {
      if (
        e?.target?.tagName?.toLowerCase?.() === 'a' &&
        e?.target?.dataset?.href
      ) {
        e?.preventDefault?.();
        e?.stopPropagation?.();

        if (bridge.runInsdk()) {
          bridge.callSdkMethod('openWebView', {
            url: e?.target?.dataset?.href,
            loginDir: 0,
            appendParams: 0
          });
        } else {
          window.open(e?.target?.dataset?.href, '_blank');
        }
      }
    }
  },
  beforeDestroy() {
    this.showContent = false;
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/_dimen.scss';
$btnH: 54px;
$deeppGray: #414141;
$lightGray: #949494;
$lightGrayBroder: #a7a7a7;
$contentFz: 24px;
$green: #57ae67;
$greenBorder: #76bc83;
$linghtGrayBg: #f3f3f3;
$shortBtnW: 210px;
$longBtnW: 420px;
$closeDlgBtnH: 24px;
$closeDlgBtnW: 24px;
$closeDlgBtnBt: 30px;
$tostW: 597px;
$tostLH: 48px;
$tostFz: 28px;
$functionL: 78px;
$functionBtm: 10px;
$headerBtm: 20px;
$dialogW: 691px;
$dialogH: 494px;
$dialogTitleFz: 48px;
$tipsContentFz: 28px;
$tipsContentLh: 56px;
%btn {
  height: $btnH;
  line-height: $btnH;
  text-align: center;
  font-size: 26px;
  color: var(--global-tip-popup-btn);
}
.ocean-ui-dialog-page {
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 30;
  justify-content: center;
  align-items: center;
}
.my-tips-dialog {
  position: relative;
  z-index: 10;
  box-sizing: border-box;
  padding: 14px;
  padding-top: 10px;
  width: 550px;
  min-height: 308px;
  background: white;
  .tips-dialog-wrapper {
    width: 100%;
    height: 100%;
    min-height: 284px;
    background: $linghtGrayBg;
  }
}

@mixin btn($bgColor, $width) {
  width: $width;
  background-color: $bgColor;

  @extend %btn;
}

@mixin shortBtn() {
  width: $shortBtnW;

  @extend %btn;
}

@mixin LongBtn() {
  width: $longBtnW;

  @extend %btn;
}
.tips-dialog-close-btn {
  position: absolute;
  right: 20px;
  top: 10px;
  z-index: 10;
  border-radius: $closeDlgBtnH;
  background-size: 100% 100%;
}
.diaglog-wrapper {
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1001;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.dialog-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.dialog-container {
  position: relative;
  z-index: 10;
  background-size: 100% 100%;
  @psetbg ('common-popup.png',true,false);
}
.dialog-tips-content {
  display: table-cell;
  clear: both;
  margin: 0 auto;
  padding: 0 30px;
  width: 100%;
  height: 80px;
  line-height: 40px;
  vertical-align: middle;
  text-align: center;
  font-size: 28px;
  color: var(--global-tip-popup-text);
  white-space: pre-wrap;
  &.autoHeight {
    height: auto;
    overflow-y: auto;
    max-height: 500px;
    min-height: 200px;
  }
  &.notice {
    padding: 0 45px;
  }
  &.left {
    text-align: left;
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
.tips-dialog-title {
  float: left;
  margin-top: 37px;
  margin-bottom: 25px;
  width: 100%;
  text-align: center;
  font-size: $dialogTitleFz;
}
.tips-dialog-content {
  clear: both;
  margin: 0 auto;
  padding: 0 71.5px;
  width: 342px;
  height: $tipsContentLh;
  line-height: 26px;
  vertical-align: middle;
  text-align: center;
  font-size: $tipsContentFz;
  white-space: pre-wrap;
}
.tips-dialog-ops {
  display: flex;
  justify-content: space-around;
  margin-top: 50px;
  width: 100%;
  height: $btnH;
}
.longBtn {
  width: $longBtnW !important;
}
.ocean-ui-dialog-buttom {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}
.left {
  text-align: left;
}
.center {
  display: block;
  box-sizing: border-box;
}
.close-btn {
  // 这里
  position: absolute;
  @psetbg ('close.png');
}
.account-ops {
  .cancel-btn {
    // 这里
    position: relative;
    margin-right: 10px;
    @psetbg ('cancel.png');
  }
  .confirm-btn {
    // 这里
    position: relative;
    @psetbg ('confirm.png');
  }
  .long-btn {
    // 这里
    position: relative;
    @psetbg ('confirm.png');
  }
}
.daysLimit {
  font-size: 18px;
  color: #fff;
  margin: 20px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  .popupCheck {
    display: inline-block;
    margin-right: 6px;
    @psetbg ('popup-check.png');
    &.active {
      display: inline-block;
      @psetbg ('popup-check-active.png');
    }
  }
}
@media screen and (orientation: landscape) {
  .dialog-container {
    // position: relative;
    // z-index: 10;
    // @psetbg ('common-popup-hen.png',true,false);
  }
  .noRightCenterNotice {
    position: relative;
    z-index: 10;
    @psetbg ('common-popup-hen.png',true,false);
  }
  .account-ops {
    .cancel-btn {
      // 这里
      position: relative;
      @psetbg ('cancel-hen.png');
    }
    .confirm-btn {
      // 这里
      position: relative;
      @psetbg ('confirm-hen.png');
    }
    .long-btn {
      // 这里
      position: relative;
      @psetbg ('confirm-hen.png');
    }
  }
  .close-btn {
    // 这里
    position: absolute;
    @psetbg ('close-hen.png');
  }
}
</style>

<style lang="scss">
.dialog-tips-content {
  a {
    color: inherit;
    word-break: break-all;
    cursor: pointer;
  }
}
</style>
